import BoxIcon from "SVGS/BoxIcon";
const noData = (props) => {
  return (
    <div className=" text-secondaryLight">
      <div className="pt-2 d-flex align-items-center">
        {props.customMessage ? (
          <p className="pl-2 text-danger">{props.customMessage}</p>
        ) : (
          <div className="flex flex-col items-center opacity-55">
            <BoxIcon />
            <p className="text-sm mt-1 font-semibold pointer-events-none select-none">
              No Data
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
export default noData;
